const determineInitiativesPlanningSummary = (initiatives = []) => {
  const planningGroups = {
    '<not set>': [],
    'Not planned (L1)': [],
    'Not planned (L2)': [],
    'Not planned (L3)': [],
    'Not planned (L4)': [],
    'Not planned (L5)': [],
    'Past due for L1': [],
    'Past due for L2': [],
    'Past due for L3': [],
    'Past due for L4': [],
    'Past due for L5': [],
    'Due soon for L1': [],
    'Due soon for L2': [],
    'Due soon for L3': [],
    'Due soon for L4': [],
    'Due soon for L5': [],
    'Due soon for L1 for 30 days': [],
    'Due soon for L2 for 30 days': [],
    'Due soon for L3 for 30 days': [],
    'Due soon for L4 for 30 days': [],
    'Due soon for L5 for 30 days': [],
    'On plan': [],
    'Realized': [],
    'Cancelled': [],
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;

    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };

    const parts = dateString.split(' ');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = monthMap[parts[1]];
      const year = parseInt(parts[2], 10);

      const d = new Date(year, month, day);
      d.setHours(0, 0, 0, 0); // ✅ normalize
      return d;
    }

    const d = new Date(dateString);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const stageConfig = {
    L0: { nextStage: 'L1' },
    L1: { nextStage: 'L2' },
    L2: { nextStage: 'L3' },
    L3: { nextStage: 'L4' },
    L4: { nextStage: 'L5' },
  };

  for (const initiative of initiatives) {
    if (initiative.weeklyStatus === 'Cancelled') {
      planningGroups['Cancelled'].push(initiative);
      continue;
    }

    const stage = initiative.stage;

    if (stage === 'L5') {
      planningGroups['Realized'].push(initiative);
      continue;
    }

    if (!stageConfig[stage]) {
      planningGroups['<not set>'].push(initiative);
      continue;
    }

    const { nextStage } = stageConfig[stage];

    const nextStageEntry = initiative.timeline?.find(
      (entry) => entry.stage === nextStage && entry.date?.plan
    );

    if (!nextStageEntry) {
      planningGroups[`Not planned (${nextStage})`].push(initiative);
      continue;
    }

    const planDate = parseDate(nextStageEntry.date.plan);

    if (!planDate || isNaN(planDate.getTime())) {
      planningGroups[`Not planned (${nextStage})`].push(initiative);
      continue;
    }

    // ✅ Correct day difference
    const diffInDays = Math.floor(
      (planDate - today) / (1000 * 60 * 60 * 24)
    );

    // ✅ Accurate classification
    if (diffInDays < 0) {
      planningGroups[`Past due for ${nextStage}`].push(initiative);

    } else {
      // 0–30 days always go to 30-day group
      if (diffInDays >= 0 && diffInDays <= 30) {
        planningGroups[`Due soon for ${nextStage} for 30 days`].push(initiative);
      }

      // 0–7 days ALSO go to 7-day group
      if (diffInDays >= 0 && diffInDays <= 7) {
        planningGroups[`Due soon for ${nextStage}`].push(initiative);
      }

      // >30 days
      if (diffInDays > 30) {
        planningGroups['On plan'].push(initiative);
      }
    }
  }

  return planningGroups;
};

export default determineInitiativesPlanningSummary;